var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnSettingsScreenNotActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.845,
    height: 21.845,
    viewBox: "0 0 21.845 21.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#b7b7b7"
  }, /*#__PURE__*/React.createElement("style", null, "\n      .a,\n      .b {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .a {\n        stroke: #b7b7b7;\n        stroke-width: 1.5px;\n      }\n\n      .b {\n        stroke: #b7b7b7;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(6.693 6.153)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.076,4.452a1.9,1.9,0,0,1,3.693,0,1.9,1.9,0,0,0,2.837,1.175A1.9,1.9,0,0,1,20.219,8.24a1.9,1.9,0,0,0,1.174,2.836,1.9,1.9,0,0,1,0,3.693,1.9,1.9,0,0,0-1.175,2.837,1.9,1.9,0,0,1-2.613,2.613,1.9,1.9,0,0,0-2.836,1.174,1.9,1.9,0,0,1-3.693,0,1.9,1.9,0,0,0-2.837-1.175,1.9,1.9,0,0,1-2.613-2.613,1.9,1.9,0,0,0-1.174-2.836,1.9,1.9,0,0,1,0-3.693A1.9,1.9,0,0,0,5.627,8.239,1.9,1.9,0,0,1,8.24,5.626a1.9,1.9,0,0,0,2.836-1.174Z",
    transform: "translate(-3 -3)",
    fill: "#b7b7b7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSettingsScreenNotActive);
export default __webpack_public_path__ + "static/media/icn-settings-screen-not-active.df793de94798b7c1132a9e545c5fa5d9.svg";
export { ForwardRef as ReactComponent };